import PolarisIcon from './PolarisIcon';
import CentralLoggingIcon from './CentralLoggingIcon';
import ThubanIcon from './ThubanIcon';

export const siteCards = [
  {
    id: 'polaris',
    title: 'Polaris',
    description: 'Highly customizable single-unit solution for all config + data + execution + validation scenarios.',
    icon: PolarisIcon,
    tone: 'brand',
    color: '#1e69f5',
    path: '/polaris',
    isExternal: false,
  },

  {
    id: 'central-logging',
    title: 'Central Logging',
    description: 'The Central Logging Pipeline is a unified solution designed to efficiently process logs.',
    icon: CentralLoggingIcon,
    tone: 'critical',
    color: '#f34f1c',
    path: 'http://aka.ms/centrallog',
    isExternal: true,
  },
  {
    id: 'thuban',
    title: 'Thuban',
    description: 'Thuban is for a set of common tools and service, Central Logging, Configuration System, Testing Infra, Service Lifecyle Management, Common Libraries and Linux Support.',
    icon: ThubanIcon,
    tone: 'warning',
    color: '#f7c500',
    path: 'http://aka.ms/thuban',
    isExternal: true,
  },
];